(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  let cartBusy = false;
  let variantAbort;
  let searchAbort;
  let searchTimer;
  let opener;

  const open = id => {
    const d = document.getElementById(id);
    if (!d || d.open) return;

    opener = document.activeElement;
    d.showModal();

    if (id === 'SearchDialog') {
      qs('[data-predictive]', d)?.focus();
    }
  };

  const close = d => {
    if (!d) return;
    d.close();
    opener?.focus?.();
  };

  /*
   * ============================================================
   * GALLERY
   * ============================================================
   */

  function showMedia(section, mediaId) {
    if (!mediaId) return false;

    const gallery = qs(
      '[data-gallery]',
      section
    );

    const target = qs(
      `#Media-${mediaId}`,
      section
    );

    if (!gallery || !target) {
      return false;
    }

    /*
     * Temporarily disable CSS smooth scrolling.
     */
    const oldBehavior =
      gallery.style.scrollBehavior;

    gallery.style.scrollBehavior = 'auto';

    /*
     * scrollIntoView is used instead of calculating
     * offsetLeft. This works even when the gallery
     * has gaps, padding, transforms, etc.
     */
    target.scrollIntoView({
      behavior: 'instant',
      block: 'nearest',
      inline: 'start'
    });

    /*
     * Force the horizontal position again.
     */
    const first =
      gallery.firstElementChild;

    gallery.scrollLeft =
      target.offsetLeft -
      (first ? first.offsetLeft : 0);

    gallery.style.scrollBehavior =
      oldBehavior;

    /*
     * Update thumbnail.
     */
    qsa(
      '[data-media-target]',
      section
    ).forEach(button => {
      button.setAttribute(
        'aria-current',
        String(
          button.dataset.mediaTarget ===
          `Media-${mediaId}`
        )
      );
    });

    return true;
  }

  /*
   * ============================================================
   * OPEN / CLOSE / MEDIA CLICKS
   * ============================================================
   */

  document.addEventListener('click', e => {
    const trigger =
      e.target.closest('[data-open]');

    if (trigger) {
      open(trigger.dataset.open);
      return;
    }

    const dismiss =
      e.target.closest('[data-close]');

    if (dismiss) {
      close(dismiss.closest('dialog'));
      return;
    }

    const zoom =
      e.target.closest('[data-zoom]');

    if (zoom) {
      const image =
        qs('#ZoomDialog img');

      if (image) {
        image.src =
          zoom.dataset.zoom;
      }

      open('ZoomDialog');
      return;
    }

    const media =
      e.target.closest(
        '[data-media-target]'
      );

    if (media) {
      const section =
        media.closest(
          '[data-product-section]'
        );

      const target =
        document.getElementById(
          media.dataset.mediaTarget
        );

      if (!target) return;

      const gallery =
        target.closest('[data-gallery]');

      if (gallery) {
        const reduce =
          matchMedia(
            '(prefers-reduced-motion:reduce)'
          ).matches;

        const oldBehavior =
          gallery.style.scrollBehavior;

        gallery.style.scrollBehavior =
          'auto';

        gallery.scrollLeft =
          target.offsetLeft -
          (gallery.firstElementChild
            ? gallery.firstElementChild.offsetLeft
            : 0);

        gallery.style.scrollBehavior =
          reduce ? 'auto' : oldBehavior;
      }

      if (section) {
        qsa(
          '[data-media-target]',
          section
        ).forEach(button => {
          button.setAttribute(
            'aria-current',
            String(button === media)
          );
        });
      }

      return;
    }

    if (
      e.target.closest('[data-sticky-add]')
    ) {
      qs(
        '#MainProductForm'
      )?.requestSubmit();
    }

    const change =
      e.target.closest(
        '[data-cart-change]'
      );

    if (change) {
      changeCart(
        change.dataset.cartChange,
        Number(change.dataset.quantity)
      );
    }
  });

  /*
   * ============================================================
   * DIALOGS
   * ============================================================
   */

  qsa('dialog').forEach(dialog => {
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;

      const rect =
        dialog.getBoundingClientRect();

      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        close(dialog);
      }
    });
  });

  /*
   * ============================================================
   * MEGA MENU
   * ============================================================
   */

  qsa('.mega').forEach(details => {
    details.addEventListener(
      'toggle',
      () => {
        if (!details.open) return;

        qsa('.mega')
          .filter(d => d !== details)
          .forEach(d => {
            d.open = false;
          });
      }
    );

    details.addEventListener(
      'keydown',
      e => {
        if (e.key !== 'Escape') return;

        details.open = false;

        qs(
          'summary',
          details
        )?.focus();
      }
    );
  });

  document.addEventListener(
    'click',
    e => {
      if (e.target.closest('.mega')) {
        return;
      }

      qsa('.mega').forEach(d => {
        d.open = false;
      });
    }
  );

  /*
   * ============================================================
   * CART
   * ============================================================
   */

  window.slzRefreshCart =
    async () => {
      const res =
        await fetch(
          SoundLabz.root +
          '?sections=cart-drawer'
        );

      if (!res.ok) {
        throw Error(
          'Cart was updated. Open the cart page to review it.'
        );
      }

      const json =
        await res.json();

      if (!json['cart-drawer']) {
        throw Error(
          'Cart was updated. Refresh to review it.'
        );
      }

      const doc =
        new DOMParser()
          .parseFromString(
            json['cart-drawer'],
            'text/html'
          );

      const content =
        qs(
          '[data-cart-content]',
          doc
        );

      const current =
        qs('[data-cart-content]');

      if (content && current) {
        current.innerHTML =
          content.innerHTML;
      }

      const page =
        qs('[data-cart-page]');

      if (page && content) {
        page.innerHTML =
          content.innerHTML;
      }

      const count =
        qs(
          '[data-cart-count]',
          doc
        )?.textContent || '0';

      qsa(
        '[data-cart-count]'
      ).forEach(n => {
        n.textContent = count;
      });
    };

  async function changeCart(
    id,
    quantity
  ) {
    if (
      cartBusy ||
      !Number.isFinite(quantity) ||
      quantity < 0
    ) {
      return;
    }

    cartBusy = true;

    const error =
      qs('[data-cart-error]');

    if (error) {
      error.textContent = '';
    }

    try {
      const response =
        await fetch(
          SoundLabz.root +
          'cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
              id,
              quantity
            })
          }
        );

      const json =
        await response.json();

      if (!response.ok) {
        throw Error(
          json.description ||
          SoundLabz.strings.error
        );
      }

      await window.slzRefreshCart();

    } catch (e) {
      if (error) {
        error.textContent =
          e.message;
      }

      const toast =
        qs('#toast');

      if (toast) {
        toast.hidden = false;
        toast.textContent =
          e.message;

        setTimeout(() => {
          toast.hidden = true;
        }, 6000);
      }
    } finally {
      cartBusy = false;
    }
  }

  /*
   * ============================================================
   * ADD TO CART
   * ============================================================
   */

  document.addEventListener(
    'submit',
    async e => {
      const form =
        e.target.closest(
          '[data-cart-form]'
        );

      if (!form) return;

      e.preventDefault();

      const button =
        qs(
          '[type=submit],button',
          form
        );

      if (
        !button ||
        button.disabled
      ) {
        return;
      }

      const original =
        button.innerHTML;

      button.disabled = true;
      button.textContent =
        SoundLabz.strings.adding;

      const error =
        qs(
          '[data-form-error]',
          form
        );

      if (error) {
        error.textContent = '';
      }

      let added = false;

      try {
        const response =
          await fetch(
            SoundLabz.root +
            'cart/add.js',
            {
              method: 'POST',
              body:
                new FormData(form),
              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        const data =
          await response.json();

        if (!response.ok) {
          throw Error(
            data.description ||
            SoundLabz.strings.error
          );
        }

        added = true;

        await window.slzRefreshCart();

        open('CartDialog');

      } catch (e) {
        const message =
          added
            ? 'Item added. Open your cart to review it.'
            : e.message;

        if (error) {
          error.textContent =
            message;
        } else {
          const toast =
            qs('#toast');

          if (toast) {
            toast.textContent =
              message;

            toast.hidden = false;

            setTimeout(() => {
              toast.hidden = true;
            }, 5000);
          }
        }
      } finally {
        button.disabled = false;
        button.innerHTML =
          original;
      }
    }
  );

  /*
   * ============================================================
   * VARIANT CHANGE
   * ============================================================
   */

  document.addEventListener(
    'change',
    async e => {
      const input = e.target;

      if (
        input.matches('[data-sort]')
      ) {
        input.form?.requestSubmit();
        return;
      }

      if (
        input.matches(
          '[data-cart-quantity]'
        )
      ) {
        changeCart(
          input.dataset.cartQuantity,
          parseInt(
            input.value,
            10
          )
        );
        return;
      }

      if (
        !input.matches(
          '[data-option-value]'
        )
      ) {
        return;
      }

      const section =
        input.closest(
          '[data-product-section]'
        );

      if (!section) return;

      /*
       * Get selected radio VALUES.
       */
      const selected =
        qsa(
          '[data-option-value]:checked',
          section
        );

      /*
       * The Liquid below gives every radio its
       * actual option name through data-option-name.
       */
      const selectedNames =
        selected.map(
          el =>
            el.dataset.optionName || ''
        );

      /*
       * Read our variant JSON.
       */
      const data =
        qs(
          '[data-variant-map]',
          section
        );

      if (!data) {
        console.error(
          'Variant data missing'
        );
        return;
      }

      let variants;

      try {
        variants =
          JSON.parse(
            data.textContent
          );
      } catch (error) {
        console.error(
          'Variant data invalid',
          error
        );
        return;
      }

      /*
       * Find exact variant by OPTION NAMES.
       */
      const variant =
        variants.find(v => {
          if (!v.options) {
            return false;
          }

          if (
            v.options.length !==
            selectedNames.length
          ) {
            return false;
          }

          return v.options.every(
            (option, index) =>
              String(option).trim() ===
              String(
                selectedNames[index]
              ).trim()
          );
        });

      /*
       * ========================================================
       * IMAGE CHANGES HERE — BEFORE ANY FETCH
       * ========================================================
       */

      if (
        variant &&
        variant.media
      ) {
        showMedia(
          section,
          String(
            variant.media
          )
        );
      }

      /*
       * Shopify option_values request.
       */
      const selectedIds =
        selected.map(
          el => el.value
        );

      variantAbort?.abort();

      variantAbort =
        new AbortController();

      section.setAttribute(
        'aria-busy',
        'true'
      );

      const button =
        qs(
          '#MainProductForm button',
          section
        );

      if (button) {
        button.disabled = true;
      }

      try {
        const url =
          new URL(
            section.dataset.productUrl,
            location.origin
          );

        url.searchParams.set(
          'option_values',
          selectedIds.join(',')
        );

        url.searchParams.set(
          'section_id',
          section.dataset.productSection
        );

        const response =
          await fetch(
            url,
            {
              signal:
                variantAbort.signal
            }
          );

        if (!response.ok) {
          throw Error(
            SoundLabz.strings.error
          );
        }

        const html =
          await response.text();

        const doc =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );

        const box =
          qs(
            '[data-buybox]',
            doc
          );

        if (!box) {
          throw Error(
            SoundLabz.strings.error
          );
        }

        const oldBox =
          qs(
            '[data-buybox]',
            section
          );

        if (oldBox) {
          oldBox.replaceWith(
            box
          );
        }

        const sticky =
          qs(
            '.sticky-buy',
            doc
          );

        const oldSticky =
          qs(
            '.sticky-buy',
            section
          );

        if (
          sticky &&
          oldSticky
        ) {
          oldSticky.replaceWith(
            sticky
          );
        }

        const id =
          qs(
            'input[name="id"]',
            box
          )?.value;

        const newUrl =
          new URL(
            location.href
          );

        if (id) {
          newUrl.searchParams.set(
            'variant',
            id
          );
        } else {
          newUrl.searchParams.delete(
            'variant'
          );
        }

        history.replaceState(
          {},
          '',
          newUrl
        );

        window.Shopify
          ?.PaymentButton
          ?.init
          ?.();

      } catch (error) {
        if (
          error.name !==
          'AbortError'
        ) {
          const formError =
            qs(
              '[data-form-error]',
              section
            );

          if (formError) {
            formError.textContent =
              error.message;
          }
        }
      } finally {
        section.removeAttribute(
          'aria-busy'
        );
      }
    }
  );

  /*
   * ============================================================
   * SEARCH
   * ============================================================
   */

  const predictive =
    qs('[data-predictive]');

  predictive?.addEventListener(
    'input',
    () => {
      clearTimeout(
        searchTimer
      );

      searchAbort?.abort();

      const query =
        predictive.value.trim();

      const results =
        qs('#SearchResults');

      if (!results) return;

      if (query.length < 2) {
        results.replaceChildren();
        return;
      }

      searchTimer =
        setTimeout(
          async () => {
            searchAbort =
              new AbortController();

            results.setAttribute(
              'aria-busy',
              'true'
            );

            try {
              const url =
                SoundLabz.root +
                'search/suggest?' +
                new URLSearchParams({
                  q: query,
                  'resources[type]':
                    'product,collection,page',
                  'resources[limit]':
                    '5',
                  section_id:
                    'predictive-search'
                });

              const res =
                await fetch(
                  url,
                  {
                    signal:
                      searchAbort.signal
                  }
                );

              if (!res.ok) {
                throw Error();
              }

              const doc =
                new DOMParser()
                  .parseFromString(
                    await res.text(),
                    'text/html'
                  );

              results.innerHTML =
                doc.body.innerHTML;

            } catch (error) {
              if (
                error.name !==
                'AbortError'
              ) {
                results.textContent =
                  'Search couldn’t load. Press Enter to see full results.';
              }
            } finally {
              results.removeAttribute(
                'aria-busy'
              );
            }
          },
          220
        );
    }
  );

  /*
   * ============================================================
   * RECOMMENDATIONS
   * ============================================================
   */

  const recommendation =
    qs(
      '[data-recommendations]'
    );

  if (
    recommendation &&
    'IntersectionObserver' in window
  ) {
    const obs =
      new IntersectionObserver(
        entries => {
          if (
            !entries[0]
              .isIntersecting
          ) {
            return;
          }

          obs.disconnect();

          fetch(
            recommendation.dataset
              .recommendations
          )
            .then(r => r.text())
            .then(html => {
              const doc =
                new DOMParser()
                  .parseFromString(
                    html,
                    'text/html'
                  );

              recommendation.innerHTML =
                qs(
                  '[data-recommendations]',
                  doc
                )?.innerHTML || '';
            })
            .catch(() => {});
        },
        {
          rootMargin: '400px'
        }
      );

    obs.observe(
      recommendation
    );
  }

  /*
   * ============================================================
   * MOTION
   * ============================================================
   */

  if (
    SoundLabz.motion &&
    !matchMedia(
      '(prefers-reduced-motion:reduce)'
    ).matches &&
    'IntersectionObserver' in window
  ) {
    const obs =
      new IntersectionObserver(
        entries => {
          entries.forEach(
            entry => {
              if (
                !entry.isIntersecting
              ) {
                return;
              }

              entry.target.classList.remove(
                'pending'
              );

              obs.unobserve(
                entry.target
              );
            }
          );
        },
        {
          threshold: 0.05
        }
      );

    qsa(
      '.section-heading,' +
      '.system-promo,' +
      '.editorial-copy,' +
      '.brand-campaign-grid>div,' +
      '.local-details'
    ).forEach(n => {
      if (
        n.getBoundingClientRect()
          .top > innerHeight
      ) {
        n.classList.add(
          'reveal',
          'pending'
        );

        obs.observe(n);
      }
    });
  }

  /*
   * ============================================================
   * SHOPIFY SECTION LOAD
   * ============================================================
   */

  document.addEventListener(
    'shopify:section:load',
    () => {
      qsa(
        '.pending'
      ).forEach(n => {
        n.classList.remove(
          'pending'
        );
      });
    }
  );
})();
